import path from "ramda/es/path";
import always from "ramda/es/always";
import compose from "ramda/es/compose";
import equals from "ramda/es/equals";
import filter from "ramda/es/filter";
import lensPath from "ramda/es/lensPath";
import lensProp from "ramda/es/lensProp";
import prop from "ramda/es/prop";
import toUpper from "ramda/es/toUpper";
import ltThanLength from "ramda-extension/es/ltThanLength";
import notEqual from "ramda-extension/es/notEqual";
import { VALID, severity } from '../constants';
export const severityP = prop('severity');
export const fieldNameLens = lensProp('fieldName');
export const validP = prop('valid');
export const validateP = prop('validate');
export const validationLens = lensPath([
    'descriptor',
    'validations'
]);
export const requiredPath = path([
    'descriptor',
    'required'
]);
export const customRequiredMessagePath = path([
    'descriptor',
    'requiredMessage'
]);
export const filterInvalid = filter(compose(notEqual(VALID), validP));
const filterPredicate = (severity)=>filter(compose(equals(severity), toUpper, severityP));
export const filterAlways = filter(always);
export const filterRequired = filterPredicate(severity.REQUIRED);
export const filterError = filterPredicate(severity.ERROR);
export const filterWarn = filterPredicate(severity.WARNING);
const hasValidationsPredicate = (filter)=>compose(ltThanLength(0), filter);
export const hasErrorValidations = hasValidationsPredicate(filterError);
export const hasRequiredValidations = hasValidationsPredicate(filterRequired);
export const hasWarnValidations = hasValidationsPredicate(filterWarn);
